<template>
  <div>
    <lida-table
      :propscolumns="columns(true,query.gamelist)"
      :data="totalItems"
      :sortStatus="false"
      align="right"
      :SpinLoading="loading"
      :propsPageSize="50"
      class="my-2"
      :LeaveSpace="false"
      :mytlpa="mytlpa"
    >
      <template v-slot:headerSelect>
        <p class="title text-left">全部</p>
      </template>
    </lida-table>
    <lida-table
      v-for="(it, key) in totalData"
      :key="key"
      :propscolumns="columns(true, key)"
      :data="it"
      :sortStatus="false"
      align="right"
      :SpinLoading="loading"
      :propsPageSize="50"
      class="my-2"
      :LeaveSpace="false"
      :ref="[`table${key}`]"
      :mytlpa="mytlpa"
    >
      <template v-slot:headerSelect>
        <p class="title text-left">{{getGamename(key)}}</p>
      </template>
    </lida-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import switchHie from "../mixins/switchHie.js"
import reportCount from '@/mixins/report-count.js'
import acountData from '@/mixins/acount-data'
export default {
  name: 'reporta7',
  mixins: [reportCount, switchHie, acountData],
  data () {
    return {
      totalData: [],
      notSunArray: ['hie', 'iscash1', 'mid', 'memcou', 'l7username', 'l7name', 'l6p'],
      loading: false
    }
  },
  computed: {
    ...mapGetters(['lidaTableCheck']),
    levelName () {
      if (this.query.lastLevel == 2) return ['', '分公司']
      let levelArray = this.acountData.filter(it => {
        return (it.level == this.query.lastLevel) || (Number(it.level) == this.query.lastLevel - 1)
      }).map(item => item.name)
      return levelArray
    }
  },
  created () {
    this.getmytlpa()
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.loading = true
      try {
        const data = {
          ...this.query,
          stid: this.query.stidlist || this.query.stid,
          repnum: 7,
        }
        const res = await this.$axios.generalLedger.linkreporta2_9(data)
        if ('status' in res && res.status === 0) return
        this.totalData = { ...this.itemsDefault(), ...res }
        this.sunTotal({ name: 'l7name', name2: 'l7username' })
        this.TableScrollTop()
        this.itemsSort()
      } catch (error) {
        console.error(error);
        this.checkUrl(error)
      } finally {
        this.loading = false
      }
    },
    columns (status = true, gameid) {
      return {
        indexNumber: {
          title: '序号',
          align: 'center',
          key: 'indexNumber',
          width: 40
        },
        l7name: {
          title: '会员',
          align: 'center',
          key: 'l7name',
          totaltext: '总计',
          notetext: '本占比总计',
          minWidth: 50,
          render: (h, params) => {
            if (this.checkFooterText(params.row.l7name)) {
              return params.row.l7name == '本占比总计'
                ? h('span', `${params.row.l7name} (${this.mytlpa}%)`)
                : h('span', params.row.l7name)
            } else {
              return h('a',
                {
                  style: {
                    cursor: status ? 'pointer' : 'text'
                  },
                  on: {
                    click: () => this.$router.push({ name: `general-ledger-reporta8`, query: { ...this.query, gmclist: gameid, mid: params.row.mid, gameid }, params: { scrollGameid: gameid } })
                  }
                },
                [
                  h('span', { class: { pc3: true, 'word-break': true } }, params.row.l7name),
                  h('span', { class: { pc2: true, 'word-break': true } }, ` ${params.row.l7username}`)
                ]
              )
            }
          },
        },
        cou: {
          title: '注数',
          align: 'center',
          key: 'cou',
          total: true,
          minWidth: 2,
          render: (h, params) => h('span', this.$commaFormat(params.row.cou))
        },
        value: {
          title: '下注金额',
          align: 'center',
          key: 'value',
          total: true,
          note: true,
          minWidth: 20,
          render: (h, params) => this.renderColorAmount(h, params, 'value')
        },
        effval: {
          title: '有效额',
          align: 'center',
          key: 'effval',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 20,
          render: (h, params) => {
            const value = params.row.effval * -1
            return h('p', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        mid: {
          title: '会员奖金',
          align: 'center',
          key: 'mid',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => {
            const value = params.row.mpaysum - params.row.payds
            return h('p', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        payds: {
          title: '会员佣金',
          align: 'center',
          key: 'payds',
          className: 'trigger-show ',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'payds')
        },
        mpaysum: {
          title: '会员盈亏',
          align: 'center',
          key: 'mpaysum',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'mpaysum')
        },
        l6p: {
          title: `${this.levelName[1]}占成(%)`,
          align: 'center',
          key: 'l6p',
          width: this.lidaTableCheck ? 40 : 100,
          render: (h, params) => {
            return !this.checkFooterText(params.row.l7name) ? h('p', `${params.row.l6p > 0 ? params.row.l6p : 0}%`) : null
          }
        },
        l6pays: {
          title: `${this.levelName[1]}占成`,
          align: 'center',
          key: 'l6pays',
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l6pays')
        },
        l6pdsd: {
          title: `${this.levelName[1]}佣金差`,
          align: 'center',
          key: 'l6pdsd',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l6pdsd')
        },
        l6paysum: {
          title: `${this.levelName[1]}盈亏`,
          align: 'center',
          key: 'l6paysum',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l6paysum')
        },
        l6upps: {
          title: `${this.levelName[1]}占成上缴`,
          align: 'center',
          key: 'l6upps',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l6upps')
        },
        l6upt: {
          title: `${this.levelName[1]}上缴`,
          align: 'center',
          key: 'l6upt',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l6upt')
        },
        l6bkpds: {
          title: `${this.levelName[1]}退佣`,
          align: 'center',
          key: 'l6bkpds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l6bkpds')
        },
        l6paysumt: {
          title: `${this.levelName[1]}占成盈亏`,
          align: 'center',
          key: 'l6paysumt',
          total: true,
          note: true,
          className: 'trigger-show',
          triggerShow: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l6paysumt')
        },
        l6pds: {
          title: `${this.levelName[1]}赚佣`,
          align: 'center',
          key: 'l6pds',
          total: true,
          note: true,
          className: 'trigger-show',
          triggerShow: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l6pds')
        },
        l5pays: {
          title: `${this.levelName[0]}占成`,
          align: 'center',
          key: 'l5pays',
          total: true,
          note: true,
          className: 'trigger-show',
          triggerShow: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l5pays')
        },
        l5upps: {
          title: `${this.levelName[0]}占成上缴`,
          align: 'center',
          key: 'l5upps',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l5upps')
        },
        l5bkpds: {
          title: `${this.levelName[0]}退佣`,
          align: 'center',
          key: 'l5bkpds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l5bkpds')
        },
        l5paysum: {
          title: `${this.levelName[0]}盈亏`,
          align: 'center',
          key: 'l5paysum',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l5paysum')
        }
      }
    }
  }
}
</script>